(() => {
  const overlay = document.getElementById('SearchOverlay');
  if (!overlay) return;

  const openSelectors = ['[data-search-overlay-open]'];
  const closeSelectors = ['[data-search-overlay-close]'];

  let lastActiveElement = null;

  const focusableSelector = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function getFocusable(container) {
    return Array.from(container.querySelectorAll(focusableSelector))
      .filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
  }

  function openOverlay() {
    if (!overlay.hasAttribute('hidden')) return;

    lastActiveElement = document.activeElement;

    overlay.removeAttribute('hidden');
    document.body.classList.add('search-overlay--open');

    // Move focus to the search input (or first focusable)
    const input = overlay.querySelector('#SearchOverlayInput');
    const focusables = getFocusable(overlay);
    const target = input || focusables[0];
    if (target) target.focus();
  }

  function closeOverlay() {
    if (overlay.hasAttribute('hidden')) return;

    overlay.setAttribute('hidden', '');
    document.body.classList.remove('search-overlay--open');

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  }

  // Open triggers: keep href behavior as no-JS fallback, but intercept when JS is active
  document.addEventListener('click', (e) => {
    const opener = openSelectors.map(sel => e.target.closest(sel)).find(Boolean);
    if (opener) {
      e.preventDefault();
      openOverlay();
      return;
    }

    const closer = closeSelectors.map(sel => e.target.closest(sel)).find(Boolean);
    if (closer) {
      e.preventDefault();
      closeOverlay();
    }
  });

  // ESC + focus trap
  overlay.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeOverlay();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusables = getFocusable(overlay);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    // If focus is outside the dialog for any reason, pull it back in
    if (!overlay.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
      return;
    }

    if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Optional: close on route change-like events (some themes replace content)
  document.addEventListener('shopify:section:unload', () => {
    closeOverlay();
  });

  // Expose minimal API if you ever want to call it from other scripts
  window.ViperiaSearchOverlay = { open: openOverlay, close: closeOverlay };
})();
